import { ceaser } from "./ceaser";


$(function() {

    if($('body').hasClass('home')){}

	$('.carousel').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
	    var i = (currentSlide ? currentSlide : 0) + 1;
	    $(this).closest('.gallery-block').find('.image-indicator').text(i + '/' + slick.slideCount);
	});

	$('.carousel').slick({
		draggable:true,
		arrows: true,
        fade:true,
		speed:500,
  		cssEase: ceaser.easeOutQuart,
  		useTransform:true,
        rows: 0, // Fix vor v1.8.0-1
	});

});